import React, { Fragment, useState, useEffect } from "react";
import moment from 'moment';
import { CustomChip } from "../../../components/chip/Chip";
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import './traditumDetalle.scss';

export const Historial = ({
    estados,
    bitacora
}) => {
    const [estadosChip] = useState({
        1: { isYellow: true },
        2: { isYellow: true },
        3: { isYellow: true },
        4: { isRed: true },
        5: { isGreen: true },
        6: { isRed: true },
        7: { isRed: true },
        8: { isRed: true }
    });

    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    const getEstado = (idEstado) => {
        const color = estadosChip[idEstado];
        const estadoName = !estados ? '' : estados?.find(x => x.id === idEstado)?.displayName;
        return (
            <CustomChip
                label={estadoName}
                {...color}
                sx={{marginLeft: '10px', height: '26px'}}
            />
        );
    };

    return <>
        <h4 className="sectionTitleHistorial">Historial</h4>
        <Timeline
            className="lineTime"
        >
            {bitacora?.map((estado, index) => {
                const isLast = index === bitacora.length - 1;
                return <>
                    <TimelineItem key={index}>
                        <TimelineOppositeContent className="leftContent">
                        <span className="date"><CalendarTodayIcon className="iconCalendar"/>{moment(estado.fecha).format("yyyy-MM-DD")}</span>
                        <span className="date">{moment(estado.fecha).format('HH:mm')}</span>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                                <TimelineDot sx={{width:'4px', height: '4px', bgcolor: '#0063BE', border: '3px solid #B9D1EB', borderRadius: '50%'}}/>
                            {!isLast && <TimelineConnector sx={{bgcolor: '#B9D1EB', border: '3px'}}/>}
                        </TimelineSeparator>
                        <TimelineContent className="rightContent">
                            <Box sx={{ width: '100%', padding: '10px', fontSize: '12px', border: '1px solid #d3d3d3', borderRadius: '6px' }}>
                                <p><strong>Observación: </strong>{estado.observacion}</p>
                                <div className="estadoHistorial"><strong>Estado: </strong>{getEstado(estado.idEstado)}</div>
                            </Box>
                        </TimelineContent>
                    </TimelineItem>
                </>
            })
            }
        </Timeline>
    </>
}